import { Navigate, useLocation, useParams } from 'react-router-dom';
import { SharedLinkClicked } from '../../stories/investor/amplitude';
import { useEffect } from 'react';
import useContextHook from './useContext';

const InvestorPrivateRoute = ({ Component }: any) => {
  const location = useLocation();
  const { propertyId } = useParams();
  const { mobileNumber } = useContextHook();

  const token = localStorage.getItem('investor-access-token');

  const params = new URLSearchParams(location.search);
  const cid = params.get('cid');
  const eq = params.get('eq');
  const eventLoggedIn = params.get('eventLoggedIn');

  useEffect(() => {
    if (token && cid && eq && propertyId && !eventLoggedIn) {
      SharedLinkClicked({
        linkCId: cid,
        linkEmailId: eq,
        mobileNumber: mobileNumber,
      });
    } else if(cid && eq && propertyId && !eventLoggedIn) {
      SharedLinkClicked({
        linkCId: cid,
        linkEmailId: eq
      });
    }
  }, [token, propertyId, cid, eq]);

  if (token && token?.length > 0) {
    return <Component />;
  }

  // Construct the continue URL with all query parameters
  const currentPath = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const continueUrl = searchParams.toString() 
    ? `${currentPath}?${searchParams.toString()}`
    : currentPath;

  return (
    <Navigate
      to={`/investor-login?continue=${encodeURIComponent(continueUrl)}`}
    />
  );
};

export default InvestorPrivateRoute;
